import React from 'react';
import { useTableInstance } from '../TableContext/TableContext.esm.js';
import '../TableContext/TableProvider.esm.js';
import { ResultsSummary } from './ResultsSummary.esm.js';

function ConnectedResultsSummary({ isBackgroundFetching: deprecatedIsBackgroundFetching }) {
    const { enableRowSelect, enablePagination, isBackgroundFetching: instanceIsBackgroundFetching, isLoading, rows, page, state: { selectedRowIds, pageIndex, pageSize } } = useTableInstance();
    const pageRecord = pageSize * pageIndex;
    const totalRecords = rows.length;
    const startingRecord = pageRecord + 1;
    const endingRecord = enablePagination ? pageRecord + page.length : totalRecords;
    const selectedCount = Object.keys(selectedRowIds).length;
    const isBackgroundFetching = deprecatedIsBackgroundFetching !== null && deprecatedIsBackgroundFetching !== void 0 ? deprecatedIsBackgroundFetching : instanceIsBackgroundFetching;
    return (React.createElement(ResultsSummary, { startingRecord: startingRecord, endingRecord: endingRecord, selected: enableRowSelect ? selectedCount : undefined, totalRecords: totalRecords, isBackgroundFetching: isBackgroundFetching, isLoading: isLoading }));
}

export { ConnectedResultsSummary };
//# sourceMappingURL=ConnectedResultsSummary.esm.js.map
